import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        video_url: '',
        videoTime: 0, // 视频播放时长
        videoHeadTime: 0, // 片头播放时长
        video_finished: false, // 视频播放结束
        cur_data: [], // 当前小节数据
        next_data: [], // 下一小节数据
        quiz_type: '', // 小测验类型
        imgPrevious: false, // 图片预览显示
        currentChapterData: null, // 当前小节数据
        showPubAlertBg: false, // PC公共弹窗浅黑色背景
        showPubAlertBgH5: false, // h5公共弹窗浅黑色背景
        pubMessbox: false, // PC公共提示框显示
        currentChapterIndex: 0, // 当前小节数组下标
        currentPartIndex: 0, // 当前章节下标
        lessonLocation: null,
        dragDirec: false, // pc拖拽提示
        isScormFlag: null, // 是否是带有scorm协议的课件
        imgPreviousUrl: '', // 当前预览图片地址
        courseAlertStatus: false,
        courseInfoAlertStatus: false,
        chapterNumAll: 0, // 总小节数
        chapterNumCur: 0, // 当前小节数
        showList: false, // 横屏目录收起
        Zhead: false, // 片头被选中为true
        Ztail: false, // 片尾被选中为true
        inFixedVideo: 'auto', // 播放片头动画方式（click点击播放，auto自动播放）
        fixedVideoPlayer: false, // 片头动画是否被播放过
        studyProgress: 0, // 学习进度
        scaleState: true, // 移动端标题学习占比
        // 音频播放状态
        autoPalyer: false,
        // 播放状态
        audioState: 'ended',
        // 播放器链接
        audioSrc: null,
        showPrev: true, // 上下章节
        isActiveIndex: null
    },
    mutations: {
        // 播放器开关
        setAutoPlayer(state, bol) {
            state.autoPalyer = bol
        },
        // 设置播放状态
        setAudioState(state, str) {
            state.audioState = str
        },
        // 修改音频链接
        setAudioSrc(satet, str) {
            satet.audioSrc = str
        },
        video_url(state, videoUrl) {
            state.video_url = videoUrl
        },
        video_finished(state, video_finished) {
            state.video_finished = video_finished
        },
        videoTime(state, videoTime) {
            state.videoTime = videoTime
        },
        videoHeadTime(state, videoHeadTime) {
            state.videoHeadTime = videoHeadTime
        },
        cur_data(state, cur_data) {
            state.cur_data = cur_data
        },
        next_data(state, next_data) {
            state.next_data = next_data
        },
        // quiz_type(state, quiz_type) {
        //   state.quiz_type = quiz_type;
        // },
        currentChapterIndex(state, currentChapterIndex) {
            state.currentChapterIndex = currentChapterIndex
        },
        currentPartIndex(state, currentPartIndex) {
            state.currentPartIndex = currentPartIndex
        },
        showPreviousPic(state, img) {
            state.imgPrevious = img
        },
        showPubAlertBg(state, data) {
            state.showPubAlertBg = data
        },
        showPubAlertBgH5(state, data) {
            state.showPubAlertBgH5 = data
        },
        pubMessboxShow(state, data) {
            state.pubMessbox = data
        },
        currentChapterIndex(state, data) {
            state.currentChapterIndex = data
        },
        addCurrentChapter(state) {
            state.currentChapterIndex++
        },
        currentPartIndex(state, data) {
            state.currentPartIndex = data
        },
        lessonLocation(state, data) {
            state.lessonLocation = data
        },
        dragDirection(state, data) {
            state.dragDirec = data
        },
        isScormFlag(state, data) {
            state.isScormFlag = data
        },
        imgPreviousUrl(state, data) {
            state.imgPreviousUrl = data
        },
        courseAlertStatus(state, data) {
            state.courseAlertStatus = data
        },
        courseInfoAlertStatus(state, data) {
            state.courseInfoAlertStatus = data
        },
        chapterNumAll(state, data) {
            state.chapterNumAll = data
        },
        chapterNumCur(state, data) {
            state.chapterNumCur = data
        },
        showList(state, data) {
            state.showList = data
        },
        Zhead(state, data) {
            state.Zhead = data
        },
        Ztail(state, data) {
            state.Ztail = data
        },
        setInFixedVideo(state, str) {
            state.inFixedVideo = str
        },
        setFixedVideoPlayer(state, bln) {
            state.fixedVideoPlayer = bln
        },
        setStudyProgress(state, data) {
            state.studyProgress = data
        },
        setScaleState(state, bool) {
            state.scaleState = bool
        },
        showPrev(state, data) {
            state.showPrev = data
        },
        isActiveIndex(state, data) {
            state.isActiveIndex = data
        }
    },
    actions: {
        videoUrl: ({
            commit
        }) => commit('videoUrl'),
        // video_finished: ({commit}) => commit("video_finished"),
        // cur_data: ({commit}) => commit("cur_data"),
        next_data: ({
            commit
        }) => commit('next_data'),
        quiz_type: ({
            commit
        }) => commit('quiz_type')
    }
})
